import { Link } from "react-router-dom";

const groups = [
  {
    title: "浏览内容",
    links: [
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/tv" },
      { label: "影视资讯", to: "/category/news" },
      { label: "影视专题", to: "/specials" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "使用说明", to: "/about" },
      { label: "联系我们", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-primary-800 bg-primary-900 text-background-200">
      <div className="shell grid gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr_1.2fr] md:py-14">
        <div>
          <Link to="/" className="flex cursor-pointer items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
              天
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                天马传媒
              </span>
              <span className="text-[9px] tracking-[0.28em] text-background-400">TIANMA MEDIA</span>
            </span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
            专业的影视内容聚合平台。我们整理电影、电视剧与行业资讯，帮你在海量作品里更快找到想看的那一部。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {[
              { icon: "ri-weibo-line", label: "微博" },
              { icon: "ri-wechat-line", label: "微信" },
              { icon: "ri-bilibili-line", label: "哔哩哔哩" },
            ].map((social) => (
              <span
                key={social.label}
                className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-800 text-background-300"
                aria-label={social.label}
              >
                <i className={`${social.icon} text-base`}></i>
              </span>
            ))}
          </div>
        </div>

        {groups.map((group) => (
          <div key={group.title}>
            <h3 className="mb-4 font-heading text-sm font-semibold text-background-50">
              {group.title}
            </h3>
            <ul className="space-y-2.5">
              {group.links.map((link) => (
                <li key={`${group.title}-${link.label}`}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-300 transition hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h3 className="mb-4 font-heading text-sm font-semibold text-background-50">联系我们</h3>
          <p className="text-sm text-background-300">合作与内容反馈</p>
          <a
            href="mailto:hello@tianmamedia.example"
            className="mt-1 block cursor-pointer text-sm text-accent-300 hover:underline"
          >
            hello@tianmamedia.example
          </a>
          <p className="mt-4 text-xs leading-relaxed text-background-400">
            本站为影视内容展示与资讯聚合演示站，不提供任何影片播放或下载服务，所有作品信息均为演示数据。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="shell flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-400 sm:flex-row">
          <p>© 2025 天马传媒 TIANMA MEDIA. 内容仅供演示。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="cursor-pointer hover:text-accent-300">
              平台说明
            </Link>
            <Link to="/specials" className="cursor-pointer hover:text-accent-300">
              专题总览
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}